/** Arabic for text inside the generated dashboard boards, applied by i18n/dom.ts (batch 3). Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Pavements · Compliance": "الرصف · الامتثال",
  "Mandatory, location, direction and information signs — siting, legend, size and illumination. The instrument behind a vertical sign flagged in Visual Analytics.":
    "اللوحات الإلزامية ولوحات الموقع والاتجاه والمعلومات — مواقعها ونصوصها وأحجامها وإنارتها. هذه هي الوثيقة التي تستند إليها لوحة عمودية تم رصدها في التحليلات المرئية.",
  "Visual aids · Inspections · Airfield": "المساعدات البصرية · الفحوص · الجانب الجوي",
  "Inspection intervals, cleaning, photometric checking and lamp replacement for airfield lighting and signs.":
    "فترات الفحص والتنظيف والقياس الضوئي واستبدال المصابيح لإنارة الجانب الجوي ولوحاته الإرشادية.",
  "Visual aids · Maintenance · Assessments": "المساعدات البصرية · الصيانة · التقييمات",
  "Visual aids · Logistics · Projects": "المساعدات البصرية · اللوجستيات · المشاريع",
  "Projects · Safety critical · Operations": "المشاريع · حرجة للسلامة · العمليات",
  "Falling weight deflectometer and other non-destructive testing: when to use it, how to plan the survey, and how to read the result.":
    "جهاز قياس الانحراف بالوزن الساقط وغيره من الاختبارات غير الإتلافية: متى يُستخدم، وكيف يُخطط للمسح، وكيف تُقرأ النتيجة.",
  "Pavements · Assessments · Engineering": "الرصف · التقييمات · الهندسة",
  "Running a pavement management programme: the inventory, the condition survey cycle, the condition index and how a maintenance programme is built from it.":
    "إدارة برنامج لإدارة الرصف: الجرد، ودورة مسح الحالة، ومؤشر الحالة، وكيف يُبنى برنامج الصيانة منه.",
  "Pavements · Assessments · Maintenance": "الرصف · التقييمات · الصيانة",
  "Operations · Compliance": "العمليات · الامتثال",
  "Procedures for aeronautical data and information management, including data quality, originator responsibility and the aerodrome mapping data set.":
    "إجراءات إدارة بيانات ومعلومات الطيران، بما فيها جودة البيانات ومسؤولية المصدر ومجموعة بيانات خرائط المطار.",
  "Operations · Compliance · Plans": "العمليات · الامتثال · الخطط",
  "Operations · Inspections": "العمليات · الفحوص",
  "Friction · Operations · Inspections": "الاحتكاك · العمليات · الفحوص",
  "Runway geometry: length, width, slopes, strips, runway end safety areas and the clearways and stopways beside them.":
    "هندسة المدرج: الطول والعرض والميول والأشرطة ومناطق الأمان في نهاية المدرج والمناطق الخالية ومناطق التوقف المجاورة لها.",
  "Airfield · Engineering · Plans": "الجانب الجوي · الهندسة · الخطط",
  "Taxiway geometry and separation, fillets, apron layout, stand clearances and holding positions.":
    "هندسة ممرات الطائرات والفواصل بينها، والحواف الموسّعة، وتخطيط ساحة وقوف الطائرات، وخلوص مواقف الطائرات، ونقاط الانتظار.",
  "Airfield electrical distribution, constant current regulators, secondary power supply and switch-over times for visual aids.":
    "توزيع الكهرباء في الجانب الجوي، ومنظمات التيار الثابت، والإمداد الكهربائي الثانوي، وأزمنة التحويل للمساعدات البصرية.",
  "Visual aids · Engineering · Operational resilience": "المساعدات البصرية · الهندسة · المرونة التشغيلية",
  "Frangibility requirements for equipment and installations sited near the movement area, and how frangibility is demonstrated.":
    "متطلبات قابلية الكسر للمعدات والمنشآت الواقعة قرب منطقة الحركة، وكيف تُثبت قابلية الكسر.",
  "Airfield · Visual aids · Engineering": "الجانب الجوي · المساعدات البصرية · الهندسة",
  "Master planning, land use and environmental control around the aerodrome, and guidelines for consultants and construction.":
    "التخطيط الشامل واستخدامات الأراضي والرقابة البيئية حول المطار، وإرشادات للاستشاريين والإنشاء.",
  "Projects · Plans · Sustainability": "المشاريع · الخطط · الاستدامة",
  "Performance classes for high-visibility clothing — the basis for expecting a person on the movement area to be detectable in a photograph.":
    "فئات أداء الملابس عالية الوضوح — الأساس لتوقّع أن يكون الشخص في منطقة الحركة ظاهرًا في الصورة.",
  "Safety critical · Operations": "حرجة للسلامة · العمليات",
  "OPEN THE PUBLISHER →": "افتح موقع الناشر →",
  "Free from GACA — the safety regulations index.": "مجانًا من الهيئة العامة للطيران المدني — فهرس لوائح السلامة.",
  "Free. US Government work, no copyright.": "مجاني. عمل حكومي أمريكي، دون حقوق نشر.",
  "Free. US Army Corps of Engineers, ERDC. No copyright.": "مجاني. سلاح المهندسين بالجيش الأمريكي، ERDC. دون حقوق نشر.",
  "HOW TO GET IT": "كيفية الحصول عليه",
  "Purchase from the ICAO store.": "يُشترى من متجر ICAO.",
  "Purchase from ASTM. Read together with the PAVER distress manuals below.":
    "يُشترى من ASTM. يُقرأ مع أدلة أعطال PAVER أدناه.",
  "Purchase from IATA.": "يُشترى من IATA.",
  "Purchase from IEC. Some national adoptions are cheaper.": "يُشترى من IEC. بعض الاعتمادات الوطنية أرخص.",
  "Purchase from IEC.": "يُشترى من IEC.",
  "NFPA offers free read-only access after registration; a copy to keep is a purchase.":
    "تتيح NFPA قراءة مجانية بعد التسجيل؛ أما النسخة الدائمة فتُشترى.",
  "NFPA offers free read-only access after registration.": "تتيح NFPA قراءة مجانية بعد التسجيل.",
  "Purchase from CEN or a national standards body.": "يُشترى من CEN أو من جهة مواصفات وطنية.",
  "Purchase from ISO.": "يُشترى من ISO.",
  "Purchase from a standards body.": "يُشترى من جهة مواصفات.",
  "Visual aids": "المساعدات البصرية",
  Rubber: "المطاط",
  "Certification Overview": "نظرة عامة على الاعتماد",
  "Certificates on File": "الشهادات المحفوظة",
  "what is certified, what has lapsed, and what the records actually support":
    "ما هو معتمد، وما انتهت صلاحيته، وما تدعمه السجلات فعلًا",
  "Asset certification": "اعتماد الأصول",
  "PRINT THE PACK": "اطبع الحزمة",
  "Maintenance current": "الصيانة محدّثة",
  "Document on file": "المستند محفوظ",
  "Complete on all three": "مكتمل في الثلاثة",
  "Certificates against the records behind them": "الشهادات مقابل السجلات التي تستند إليها",
  PAPER: "الورق",
  "none linked": "لا يوجد ربط",
  "Paper is whether the certificate is in date. Maintenance is whether the programmes it depends on are current. A row that is green on one and amber on the other is the row an auditor finds.":
    "الورق يعني هل الشهادة سارية. الصيانة تعني هل البرامج التي تعتمد عليها محدّثة. الصف الأخضر في أحدهما والكهرماني في الآخر هو الصف الذي يجده المدقق.",
  "Certification by asset": "الاعتماد حسب الأصل",
  "LIGHTNING · Facilities manager": "LIGHTNING · مدير المرافق",
  "STATUTORY INSPECTION": "فحص نظامي",
  "Approved contractor": "مقاول معتمد",
  action: "إجراء",
  "AGL · Maintenance manager": "AGL · مدير الصيانة",
  "AERODROME CERTIFICATION": "اعتماد المطار",
  "LIFTS · Facilities manager": "LIFTS · مدير المرافق",
  "Notified body": "جهة مُخطَرة",
  "LOLER · Maintenance manager": "LOLER · مدير الصيانة",
  "Competent person": "شخص مؤهل",
  "GSE · Ground operations": "GSE · العمليات الأرضية",
  "TYPE APPROVAL OR CONFORMITY": "اعتماد النوع أو المطابقة",
  "Aerodrome operator": "مشغّل المطار",
  CALIBRATION: "المعايرة",
  "Flight inspection": "فحص جوي",
  "Flight inspection unit": "وحدة الفحص الجوي",
  "FRICTION-RIG · Airside operations": "FRICTION-RIG · عمليات الجانب الجوي",
  "SCREENERS · Security manager": "SCREENERS · مدير الأمن",
  "OPERATOR COMPETENCE": "كفاءة المشغّل",
  "GACA security": "أمن الهيئة العامة للطيران المدني",
  "WATER · Facilities manager": "WATER · مدير المرافق",
  "Health authority": "الجهة الصحية",
  "FIRE-SYS · Facilities manager": "FIRE-SYS · مدير المرافق",
  "FUEL · Fuel operator": "FUEL · مشغّل الوقود",
  "RFF-BA · RFF station manager": "RFF-BA · مدير محطة RFF",
  "Approved test house": "مختبر اختبار معتمد",
  "SCREEN · Security manager": "SCREEN · مدير الأمن",
  "ADP · Airside operations": "ADP · عمليات الجانب الجوي",
  "HBS · Security manager": "HBS · مدير الأمن",
  "GENSETS · Maintenance manager": "GENSETS · مدير الصيانة",
  "FIRE-PUMP · Facilities manager": "FIRE-PUMP · مدير المرافق",
  "PRESSURE · Maintenance manager": "PRESSURE · مدير الصيانة",
  "BHS · Facilities manager": "BHS · مدير المرافق",
  "LV-SYS · Maintenance manager": "LV-SYS · مدير الصيانة",
  "SWEEPERS · Airside operations": "SWEEPERS · عمليات الجانب الجوي",
  "WARRANTY OR SERVICE CONTRACT": "ضمان أو عقد خدمة",
  "Manufacturer service contract": "عقد خدمة مع الشركة المصنّعة",
  "what expires next, and how long it takes to renew": "ما ينتهي تاليًا، وكم يستغرق تجديده",
  "Facilities manager": "مدير المرافق",
  "START NOW": "ابدأ الآن",
  "Maintenance manager": "مدير الصيانة",
  "Ground operations": "العمليات الأرضية",
  "Security manager": "مدير الأمن",
  "Fuel operator": "مشغّل الوقود",
  "RFF station manager": "مدير محطة RFF",
  "EXPECTED EVIDENCE": "الأدلة المتوقعة",
  "Photometric survey, Circuit insulation records": "مسح ضوئي، سجلات عزل الدوائر",
  "Examination reports, Defect close-out": "تقارير الفحص، إغلاق العيوب",
  "Flight inspection report": "تقرير الفحص الجوي",
  "Correlation certificate": "شهادة المطابقة بين الأجهزة",
  "Certification roll": "سجل الاعتماد",
  "Laboratory results": "نتائج المختبر",
  "Verification certificate, Zone test sheets": "شهادة التحقق، أوراق اختبار المناطق",
  "Friction survey, Pavement inspection": "مسح الاحتكاك، فحص الرصف",
  "Integrity report": "تقرير السلامة الإنشائية",
  "Hydrostatic test certificates": "شهادات الاختبار الهيدروستاتيكي",
  "Approval letter": "خطاب الموافقة",
  "Permit roll": "سجل التصاريح",
  "Standard approval, Daily test records": "اعتماد المعيار، سجلات الاختبار اليومية",
  "Load bank test report": "تقرير اختبار الحمل",
  "Foam test certificate": "شهادة اختبار الرغوة",
  "Pump curve test": "اختبار منحنى المضخة",
  "Examination reports": "تقارير الفحص",
  "Conformity declaration": "إقرار المطابقة",
  "EICR schedules": "جداول EICR",
  Contract: "العقد",
  "ten measures against target, graded, for the daily review": "عشرة مقاييس مقابل المستهدف، بتقدير، للمراجعة اليومية",
  "PRINT THE BOARD REPORT": "اطبع تقرير مجلس الإدارة",
  "SET TARGETS": "حدّد المستهدفات",
  "Overall grade": "التقدير العام",
  "Grade mix": "توزيع التقديرات",
  "Against target, worst first": "مقابل المستهدف، الأسوأ أولًا",
  "AODB departure times": "أوقات المغادرة من AODB",
  "incident register, serious and open": "سجل الحوادث، الخطيرة والمفتوحة",
  "incident register, access control and the security posting": "سجل الحوادث، التحكم في الدخول والانتشار الأمني",
  "passenger feed against the annual plan": "بيانات الركاب مقابل الخطة السنوية",
  "queue counters and the checkpoint feed": "عدّادات الطوابير وبيانات نقطة التفتيش",
  "lifts, bridges, baggage lines and screening lanes": "المصاعد والجسور وخطوط الأمتعة وممرات التفتيش",
  "disruption feed, or inferred from the weather when it is not fed":
    "بيانات الاضطرابات، أو تُستنتج من الطقس عند عدم توفرها",
  "finance feed": "بيانات المالية",
  "revenue, cost, capital and how each sits against budget": "الإيرادات والتكلفة ورأس المال وموقع كل منها من الميزانية",
  "Financial performance": "الأداء المالي",
  "awaiting the finance system": "بانتظار النظام المالي",
  "Revenue, cost and capital figures come from the finance system. Until it is connected this page has nothing to show — and an empty finance page is better than an invented one.":
    "أرقام الإيرادات والتكلفة ورأس المال تأتي من النظام المالي. حتى يتم ربطه لا تعرض هذه الصفحة شيئًا — وصفحة مالية فارغة أفضل من صفحة بأرقام مختلقة.",
  "requests, the approval chain and purchase orders": "الطلبات وسلسلة الموافقات وأوامر الشراء",
  "Approvals and purchase orders": "الموافقات وأوامر الشراء",
  "RAISE A REQUEST": "أنشئ طلبًا",
  "no approving role chosen": "لم يتم اختيار دور موافقة",
  "Set your name on the Engineering page, then add a signature.": "اكتب اسمك في صفحة الهندسة، ثم أضف توقيعًا.",
  "ADD MY SIGNATURE": "أضف توقيعي",
  "CEO · NO LIMIT": "الرئيس التنفيذي · دون حد",
  "Value in the chain": "القيمة في السلسلة",
  "Purchase orders": "أوامر الشراء",
  "Value committed": "القيمة الملتزم بها",
  "Emergency, ratified after the fact": "طارئ، يُصادق عليه لاحقًا",
  REQUEST: "الطلب",
  "Out of scope work": "عمل خارج النطاق",
  "Emergency repair": "إصلاح طارئ",
  "purchase order issued": "صدر أمر الشراء",
  Purchase: "شراء",
  "New maintenance work": "عمل صيانة جديد",
  SUPPLIER: "المورّد",
  "What other approvers have done": "ما قام به الموافقون الآخرون",
  "No approvals have been recorded in this session. The trail starts empty each time the page is opened — it is a working record, not a register.":
    "لم تُسجَّل أي موافقات في هذه الجلسة. يبدأ السجل فارغًا في كل مرة تُفتح فيها الصفحة — إنه سجل عمل، وليس سجلًا رسميًا.",
  "What each step is asked to decide": "ما يُطلب من كل خطوة أن تقرره",
  "Engineering manager": "مدير الهندسة",
  "Contracts manager": "مدير العقود",
  "Purchasing manager": "مدير المشتريات",
  "Has it been sourced properly, and is the supplier approved?": "هل تم التوريد بالطريقة الصحيحة، وهل المورّد معتمد؟",
  "Finance manager": "المدير المالي",
  "Chief Operating Officer": "الرئيس التنفيذي للعمليات",
  "Chief Executive Officer": "الرئيس التنفيذي",
  "no limit": "دون حد",
  "Final authority. Beyond this the airport is committed.": "الصلاحية النهائية. بعدها يصبح المطار ملتزمًا.",
  "stock, consumption and what needs reordering": "المخزون والاستهلاك وما يحتاج إلى إعادة طلب",
  "Logistics and warehouse": "اللوجستيات والمستودع",
  "awaiting the stores system": "بانتظار نظام المخازن",
  "Stock, receipts and consumption come from the stores system. Until it is connected this page has nothing to show — an invented stock figure is worse than none.":
    "المخزون والاستلامات والاستهلاك تأتي من نظام المخازن. حتى يتم ربطه لا تعرض هذه الصفحة شيئًا — رقم مخزون مختلق أسوأ من عدمه.",
  "carbon, energy, waste, noise and the demand ahead": "الكربون والطاقة والنفايات والضوضاء والطلب المستقبلي",
  "Sustainability and future readiness": "الاستدامة والجاهزية للمستقبل",
  "awaiting the environment and planning feeds": "بانتظار بيانات البيئة والتخطيط",
  "Emissions, energy, waste, noise and the demand forecast come from the environment office and the planning team. Nothing on this page is estimated from activity — until those are connected it has nothing to show.":
    "الانبعاثات والطاقة والنفايات والضوضاء وتوقعات الطلب تأتي من مكتب البيئة وفريق التخطيط. لا شيء في هذه الصفحة مقدَّر من النشاط — حتى يتم ربطها لا تعرض شيئًا.",
  "Systems Intelligence": "ذكاء الأنظمة",
  "System Diagnostics": "تشخيص النظام",
  "what is abnormal, what is failing, and what is coming": "ما هو غير طبيعي، وما يتعطل، وما هو قادم",
  "Incident register · everything reported": "سجل الحوادث · كل ما تم الإبلاغ عنه",
  "eight sections, run against this build rather than describing one":
    "ثمانية أقسام، تُشغَّل على هذا الإصدار بدلًا من وصف أحدها",
  "RUN TEST": "شغّل الاختبار",
  "What this does": "ما يفعله هذا",
  "Data health and integrity": "سلامة البيانات وتكاملها",
  "Predictive model performance": "أداء النماذج التنبؤية",
  "Models degrade. The usual cause is not a bad model but a silent change in what is being fed to it, which is why this section and the one above are read together.":
    "النماذج تتراجع. السبب المعتاد ليس نموذجًا سيئًا بل تغيّرًا صامتًا فيما يُغذّى به، ولهذا يُقرأ هذا القسم مع القسم السابق.",
  "Dashboard and front end": "لوحة المعلومات والواجهة",
  "Slow, wrong or dead controls cost trust faster than an outage, because people keep using the thing and stop believing it.":
    "أدوات التحكم البطيئة أو الخاطئة أو المعطلة تُفقد الثقة أسرع من الانقطاع، لأن الناس يستمرون في الاستخدام ويتوقفون عن التصديق.",
  Infrastructure: "البنية التحتية",
  "Security and access": "الأمن والوصول",
  "Business logic and output": "منطق العمل والمخرجات",
  "Automated tests": "الاختبارات الآلية",
  "Known inputs, known answers. This is what catches a change breaking something quietly.":
    "مدخلات معروفة، وإجابات معروفة. هذا ما يكشف تغييرًا يُعطّل شيئًا بصمت.",
  "Experience and function": "التجربة والوظائف",
  "find anything in the platform, and how to use it": "ابحث عن أي شيء في المنصة، وتعرّف على طريقة استخدامها",
  "Search anything — a stand, a work order, a document, an indicator":
    "ابحث عن أي شيء — موقف طائرة، أمر عمل، مستند، مؤشر",
  "How this platform is put together": "كيف بُنيت هذه المنصة",
  "Two kinds of number live here and they are never mixed.": "يوجد هنا نوعان من الأرقام ولا يُخلطان أبدًا.",
  "come from elsewhere; each has a slot and a documented shape, and until one is connected its tile says AWAITING FEED rather than inventing a figure. Anything badged DEMO is a demonstration value.":
    "تأتي من أماكن أخرى؛ لكل منها موضع وشكل موثّق، وحتى يتم ربطه يعرض مربعه AWAITING FEED بدلًا من اختلاق رقم. كل ما يحمل شارة DEMO قيمة توضيحية.",
  "Airfield map": "خريطة الجانب الجوي",
  "floor plans, rooms, and work raised in them": "مخططات الطوابق، والغرف، والأعمال المُنشأة فيها",
  "checklists, reports and the work they raise": "قوائم التحقق والتقارير والأعمال التي تنتج عنها",
  "accumulation, removal planning and verification": "التراكم، وتخطيط الإزالة، والتحقق",
  "Common questions": "أسئلة شائعة",
  "Open the AIRFIELD map or a building plan, click the place, and choose NEW WORK ORDER. From an inspection, a failed i…":
    "افتح خريطة الجانب الجوي أو مخطط مبنى، وانقر على المكان، واختر إنشاء أمر عمل. من فحص، بند فاشل…",
  "Every dashboard section has an incident panel with REPORT AN INCIDENT. It captures what happened, where, severity, photo…":
    "لكل قسم في لوحة المعلومات لوحة حوادث فيها الإبلاغ عن حادث. تسجّل ما حدث، وأين، والخطورة، والصورة…",
  "Operations → Emergency response → ACTIVATE OR DECLARE. Activation is timestamped, opens the twelve-agency call list, not…":
    "العمليات ← الاستجابة للطوارئ ← التفعيل أو الإعلان. يُسجَّل وقت التفعيل، وتُفتح قائمة الاتصال بالجهات الاثنتي عشرة…",
  "Push data with window.airfieldFeed(name, payload) or an airfieldmap:feed event. Every indicator's detail panel prints it…":
    "أرسل البيانات عبر window.airfieldFeed(name, payload) أو حدث airfieldmap:feed. لوحة التفاصيل لكل مؤشر تطبعه…",
  "DEMO FEEDS on the dashboard header fills every slot with plausible values, badged DEMO everywhere they appear. Clear it …":
    "زر DEMO FEEDS في رأس لوحة المعلومات يملأ كل موضع بقيم معقولة، مع شارة DEMO أينما ظهرت. امسحها…",
  "Executive KPIs prints a board report, Compliance prints a submission pack, and Documents prints blank inspection forms. …":
    "مؤشرات الأداء التنفيذية تطبع تقرير مجلس الإدارة، والامتثال يطبع حزمة تقديم، والمستندات تطبع نماذج فحص فارغة…",
  Terms: "المصطلحات",
  "Touchdown zone — the first part of the runway where aircraft land, where rubber builds up and friction falls first.":
    "منطقة ملامسة الأرض — الجزء الأول من المدرج حيث تهبط الطائرات، ويتراكم المطاط وينخفض الاحتكاك أولًا.",
  "Notice to Air Missions. Work on the movement area needs one; an uncovered worksite is flagged as an anomaly here.":
    "إشعار للطيارين. العمل في منطقة الحركة يحتاج إلى إشعار؛ وموقع العمل غير المغطى يُرصد هنا كحالة شاذة.",
  "Rescue and fire fighting. The declared category has to be available or the aerodrome operates at a lower one, which restricts the aircraft that can use it.":
    "الإنقاذ ومكافحة الحرائق. يجب أن تكون الفئة المعلنة متاحة وإلا يعمل المطار بفئة أدنى، مما يقيّد الطائرات التي يمكنها استخدامه.",
  "Single point of failure — something with no alternative if it stops.":
    "نقطة إخفاق منفردة — شيء لا بديل له إذا توقف.",
  "Mean time between failures, computed here from this airport's own work orders, findings and incident reports.":
    "متوسط الوقت بين الأعطال، محسوب هنا من أوامر العمل والملاحظات وتقارير الحوادث الخاصة بهذا المطار.",
  "Ask about this airport, about the instruments it is judged against, or about how to do a job in this platform. Choose which sources answer in the strip below the box.":
    "اسأل عن هذا المطار، أو عن الوثائق التي يُقيَّم وفقها، أو عن طريقة إنجاز مهمة في هذه المنصة. اختر المصادر التي تجيب من الشريط أسفل المربع.",
  "What needs attention right now?": "ما الذي يحتاج إلى اهتمام الآن؟",
  "What governs rubber removal and friction testing?": "ما الذي يحكم إزالة المطاط واختبار الاحتكاك؟",
  "How do I create a New Work Order?": "كيف أنشئ أمر عمل جديداً؟",
  "Its own records": "سجلاته الخاصة",
  "nothing uploaded": "لم يُرفع شيء",
  "ICAO & FAA": "ICAO وFAA",
  "AI MODEL": "نموذج الذكاء الاصطناعي",
  "not connected": "غير متصل",
  "Set this source up": "إعداد هذا المصدر",
  CONNECT: "اتصال",
  "Ask Sky-IQ — this airport, an ICAO or FAA instrument, or how to do a job here":
    "اسأل Sky-IQ — عن هذا المطار، أو وثيقة ICAO أو FAA، أو طريقة إنجاز مهمة هنا",
  "Runway friction analysis": "تحليل احتكاك المدرج",
  SATISFACTORY: "مُرضٍ",
  Distribution: "التوزيع",
  "Point at the map for the reading under the cursor. Click a cell to put that station on the aerodrome drawing.":
    "أشر إلى الخريطة لقراءة القيمة تحت المؤشر. انقر على خلية لوضع تلك النقطة على مخطط المطار.",
  MIN: "الأدنى",
  MAX: "الأعلى",
  "STD DEV": "الانحراف المعياري",
  COV: "معامل التباين",
  "Against the previous survey": "مقابل المسح السابق",
  INDICATOR: "المؤشر",
  "Network mean": "متوسط الشبكة",
  "Lowest station": "أدنى نقطة",
  "Coefficient of variation": "معامل التباين",
  "Recomputed from the readings on this page, not copied from the report. If a figure here disagrees with the printed one, that is worth knowing rather than hiding.":
    "أُعيد حسابها من القراءات في هذه الصفحة، ولم تُنسخ من التقرير. إذا اختلف رقم هنا عن الرقم المطبوع، فمن المفيد معرفة ذلك بدلًا من إخفائه.",
  RUN: "التشغيل",
  OFFSET: "الإزاحة",
  DIRECTION: "الاتجاه",
  "SECTION B": "القسم B",
  "SECTION C": "القسم C",
  "OPEN THE REPORT (PDF)": "افتح التقرير (PDF)",
  "DOWNLOAD IT": "نزّله",
  "MAKE THE RETURN": "أعدّ الإفادة",
  "+ FILE SOMETHING ELSE AGAINST THIS SURVEY": "+ احفظ مستندًا آخر على هذا المسح",
  "How it was measured": "طريقة القياس",
  EQUIPMENT: "المعدات",
  SPEED: "السرعة",
  TYRE: "الإطار",
  "WATER FILM": "طبقة الماء",
  CONDITIONS: "الظروف",
  "Reference levels": "المستويات المرجعية",
  "Design objective": "هدف التصميم",
  "mean below": "المتوسط أقل من",
  "Maintenance planning": "تخطيط الصيانة",
  "mean above": "المتوسط أعلى من",
  "Minimum friction": "الحد الأدنى للاحتكاك",
  "TOUCHDOWN ZONE, MEAN OF LAPS": "منطقة ملامسة الأرض، متوسط الأشواط",
  "TOUCHDOWN ZONE, TWO LOWEST LAPS": "منطقة ملامسة الأرض، أدنى شوطين",
  "WHOLE RUN": "التشغيل كاملًا",
  "BELOW PLANNING LEVEL": "أقل من مستوى التخطيط",
  "LAP SPREAD IN THE TDZ": "تفاوت الأشواط في TDZ",
  "through the touchdown zone.": "عبر منطقة ملامسة الأرض.",
  "ASSESSED · TWO LOWEST LAPS": "مُقيَّم · أدنى شوطين",
  "TOUCHDOWN ZONE": "منطقة ملامسة الأرض",
  LENGTH: "الطول",
  "MEAN µ": "متوسط µ",
  LOWEST: "الأدنى",
  "Surveys on file": "المسوحات المحفوظة",
  "PRE-REMOVAL": "قبل الإزالة",
  "TAP TO SET A, TAP AGAIN TO SET B. THE LATEST NON-DEMO SURVEY DRIVES RUNWAY STATUS.":
    "انقر لتحديد A، وانقر مرة أخرى لتحديد B. أحدث مسح غير تجريبي يحدد حالة المدرج.",
  "LOAD A DEMONSTRATION SURVEY": "حمّل مسحًا تجريبيًا",
  Across: "عبر",
  "NETWORK MEAN": "متوسط الشبكة",
  "LOWEST READING": "أدنى قراءة",
  "HOLLOW MARKER · SUMMARY ONLY": "علامة مفرغة · ملخص فقط",
  "apart — the network mean moved": "بفارق — تحرّك متوسط الشبكة",
  IMPROVED: "تحسّن",
  FELL: "انخفض",
  "UNIFORMITY (CoV)": "التجانس (CoV)",
  "LAP TABLES ON FILE": "جداول الأشواط المحفوظة",
  "ASFT LANE SURVEY": "مسح المسارات بجهاز ASFT",
  "SUMMARY ONLY": "ملخص فقط",
  "same lane": "للمسار نفسه",
  station: "النقطة",
  "distance friction speed": "المسافة الاحتكاك السرعة",
  "rows beneath them, plus date, equipment and speed from the header if they are present.":
    "الصفوف التي تحتها، مع التاريخ والمعدات والسرعة من الترويسة إن وُجدت.",
  "Report text or CSV": "نص التقرير أو CSV",
  "Survey date (if not in the text)": "تاريخ المسح (إن لم يرد في النص)",
  "Test speed km/h": "سرعة الاختبار km/h",
  "PARSE AND ADD SURVEY": "حلّل وأضف المسح",
  "NOT KNOWN": "غير معروف",
  "no removal on record for this end": "لا توجد إزالة مسجلة لهذه النهاية",
  "NO REMOVAL ON RECORD FOR THIS END": "لا توجد إزالة مسجلة لهذه النهاية",
  "No rubber removal recorded for this end and no friction survey on file, so neither the model nor a measurement can say where it stands. Record the last removal date, or run a survey.":
    "لا توجد إزالة مطاط مسجلة لهذه النهاية ولا مسح احتكاك محفوظ، لذا لا يستطيع النموذج ولا القياس تحديد وضعها. سجّل تاريخ آخر إزالة، أو نفّذ مسحًا.",
  "ALERT MAINTENANCE": "نبّه الصيانة",
  "Post-removal friction survey outstanding. Until it is run, this end has no current measured friction and the cycle restarts from the removal date.":
    "مسح الاحتكاك بعد الإزالة لم يُنفّذ بعد. حتى يُنفّذ، لا يوجد لهذه النهاية احتكاك مقاس حالي وتبدأ الدورة من تاريخ الإزالة.",
  "RAISE VERIFICATION WORK ORDERS": "أنشئ أوامر عمل التحقق",
  "COMPLETE THE REMOVAL RECORD": "أكمل سجل الإزالة",
  "SURFACE DEFECT": "عيب في السطح",
  "RUNWAY END": "نهاية المدرج",
  "PREDICTED LOAD": "الحمل المتوقع",
  "µ AT DUE": "µ عند الاستحقاق",
  "Landings per day": "الهبوط يوميًا",
  "Narrow body %": "ضيقة البدن %",
  "Wide body %": "عريضة البدن %",
  "Small–midsize %": "صغيرة ومتوسطة %",
  "Narrow main tyres": "إطارات رئيسية ضيقة البدن",
  "Wide main tyres": "إطارات رئيسية عريضة البدن",
  "Small main tyres": "إطارات رئيسية صغيرة",
  "First end share %": "حصة النهاية الأولى %",
  Deposition: "الترسّب",
  "Retained rubber g/tyre": "المطاط المترسّب g/إطار",
  "Touchdown zone m²": "منطقة ملامسة الأرض m²",
  "Wheel path % of zone": "مسار العجلات % من المنطقة",
  "Removal level g/m²": "مستوى الإزالة g/m²",
  "Left after removal %": "المتبقي بعد الإزالة %",
  "Accumulation model": "نموذج التراكم",
  "Untreated plateau g/m²": "الحد الأقصى دون معالجة g/m²",
  "Clean surface µ": "µ السطح النظيف",
  "Floor µ, however dirty": "الحد الأدنى لـ µ مهما بلغ التراكم",
  "Deposition uncertainty ±": "عدم يقين الترسّب ±",
  "Ravelling and Aggregate loss. Not yet surveyed — extent and chainage to be confirmed.":
    "تفكك السطح وفقدان الركام. لم يُمسح بعد — يُؤكَّد الامتداد والمسافة لاحقًا.",
  "Removal method while open": "طريقة الإزالة مع بقاء العيب مفتوحًا",
  "Chemical, low-pressure rinse": "كيميائية، مع شطف منخفض الضغط",
  "Softens rubber before it is lifted, so the aggregate is not the thing taking the load. Slowest, needs environmental control of the run-off.":
    "تُليّن المطاط قبل رفعه، فلا يتحمل الركام الحمل. الأبطأ، وتحتاج إلى ضبط بيئي لمياه الجريان.",
  "High pressure water, reduced pressure and increased standoff": "ماء عالي الضغط، بضغط مخفّض ومسافة أكبر",
  "High pressure water at standard settings": "ماء عالي الضغط بالإعدادات القياسية",
  "Not while ravelling is open — it will lift loose aggregate along with the rubber and widen the defect.":
    "ليس أثناء بقاء التفكك مفتوحًا — سيرفع الركام المفكك مع المطاط ويوسّع العيب.",
  "Shot blasting": "السفع بالكريات",
  "Most aggressive on a weakened matrix. Not appropriate until the surface is repaired or resurfaced.":
    "الأشد قسوة على سطح ضعيف. غير مناسب حتى يُصلح السطح أو يُعاد رصفه.",
  "MARK SURFACE DEFECT CLOSED": "أغلق عيب السطح",
  "µ clean surface": "µ السطح النظيف",
  "µ maintenance level": "µ مستوى الصيانة",
  "Measured µ": "µ المقاس",
  "Days since clean": "أيام منذ التنظيف",
  "CALIBRATE G/TYRE FROM THIS TEST": "عايِر g/إطار من هذا الاختبار",
  "CREATE THE NEXT ROUND OF WORK ORDERS": "أنشئ الجولة التالية من أوامر العمل",
  "SHOW ZONES ON THE MAP": "اعرض المناطق على الخريطة",
  "+ FRICTION TEST": "+ اختبار احتكاك",
  "+ REMOVAL RECORD": "+ سجل إزالة",
  EVENT: "الحدث",
  "TDZ µ": "µ في TDZ",
  MID: "الوسط",
  ROLLOUT: "التدحرج",
  "Runway ends by status": "نهايات المدرج حسب الحالة",
  "Nothing sent yet. Alerts raised here are logged and dispatched through the airfieldmap:alert event.":
    "لم يُرسل شيء بعد. التنبيهات المنشأة هنا تُسجَّل وتُرسل عبر حدث airfieldmap:alert.",
};
export default ar;
